'use strict';

module.exports = {
  __init__: [ 'replace' ],
  replace: [ 'type', require(218) ]
};
